import api from "../index"
import { apiTags } from "../tags"

const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInvestorUsers: build.query({
      query: (params) => ({
        url: `/investor/users`,
        method: "GET",
        params,
      }),
    }),
    getInvestorUser: build.query({
      query: ({ id }) => ({
        url: `/investor/users/${id}`,
        method: "GET",
      }),
    }),
    createInvestorUser: build.mutation({
      query: (params) => ({
        url: `/investor/users`,
        method: "POST",
        body: params,
      }),
    }),
    updateInvestorUser: build.mutation({
      query: ({ id, ...params }) => ({
        url: `/investor/users/${id}`,
        method: "POST",
        body: params,
      }),
    }),
    deleteInvestorUser: build.mutation({
      query: ({ id }) => ({
        url: `/investor/users/${id}`,
        method: "DELETE",
      }),
    }),
    blockInvestorUser: build.mutation({
      query: ({ id }) => ({
        url: `/investor/users/${id}/block`,
        method: "GET",
      }),
    }),
    unblockInvestorUser: build.mutation({
      query: ({ id }) => ({
        url: `/investor/users/${id}/unblock`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetInvestorUsersQuery,
  useLazyGetInvestorUserQuery,
  useCreateInvestorUserMutation,
  useUpdateInvestorUserMutation,
  useDeleteInvestorUserMutation,
  useBlockInvestorUserMutation,
  useUnblockInvestorUserMutation,
} = userApi
